export interface SlotTeacher {
  id: string
  name: string | null
  onDuty: boolean | null
}

export interface StudentFixedSlot {
  bindingId: string
  fixedSlotId: string
  teacher: SlotTeacher
  nextStart: number
  nextEnd: number | null
  nextAppointment: {
    id: string
    status: string
    cancelReason: string | null
  } | null
}

export interface StudentSingleSlot {
  appointmentId: string
  scheduleDetailId: string | null
  teacher: SlotTeacher
  start: number
  end: number | null
  type: string
  status: string
  desiredExpiresAt: number | null
}

export interface StudentOccupiedSlots {
  studentId: string
  fixedSlots: StudentFixedSlot[]
  singleSlots: StudentSingleSlot[]
  pendingRequests: StudentSingleSlot[]
  asOf: number
}

export function occurrenceState(slot: StudentFixedSlot) {
  if (!slot.nextAppointment)
    return {
      label: '尚未生成',
      color: 'warning',
      description: '固定绑定仍保留，尚未找到下个时点的预约记录。',
    }
  if (slot.nextAppointment.status === 'CANCELLED')
    return {
      label: '该次已取消',
      color: 'default',
      description: '仅该次取消，每周固定绑定仍保留。',
    }
  return { label: '已生成', color: 'success', description: '' }
}
